import { render, staticRenderFns } from "./CopyHelper.vue?vue&type=template&id=2b79d8d6&scoped=true&"
import script from "./CopyHelper.vue?vue&type=script&lang=ts&"
export * from "./CopyHelper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79d8d6",
  null
  
)

export default component.exports